<template>
  <div :class="validationContainerClass">
    <v-validate
        :rules="rules"
        :vid="name"
        v-slot="{ errors, classes }"
        :name="label"
    >
      <div class="form-group h-auto">
        <label :for="id">
          {{ label }}
          <div v-if="isRequired" class="is-required">
            <i class="fas fa-star-of-life"></i>
          </div>
        </label>
        <v-select
            dir="rtl"
            :id="inputID"
            :name="name"
            taggable
            multiple
            :ref="name"
            :label="dataTextField"
            :placeholder="placeHolder"
            v-model="content"
            :options="dataSource"
            :reduce="option => option[dataValueField]"
            @input="handleInput(content)"
            :disabled="disabled"
        />
      </div>
    </v-validate>
  </div>
</template>

<script>
import InputCommons from "./InputCommons.vue";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

export default {
  extends: InputCommons,
  components: { vSelect },
  data() {

    return {
      contentTemp: [],
    };
  },
  methods: {
    emptySelect() {
      this.content = [];
    },
    clearValue() {
      if (this.disabled) return
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();

      }
    }
  },
};
</script>

<style>
</style>